import React from "react";
import moment from "moment";
import Sidebar from "../../../components/Sidebar";
import PageHeader from "../../../components/PageHeader";
import DatePicker from "react-datepicker";
import ReportApi from "../../../services/ob-core/report";
import { getUserInfo } from "../../../utils/authority";
import { withSnackbar } from "notistack";
import {
  reportFormOptions,
  groupByOptions,
  includeTransfersOptions,
  quantityFieldsOptions,
  itemsPrintedOptions
} from "./mockdata";

class ReportSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportForm: _.get(reportFormOptions, "[0].value"),
      dateFrom: null,
      dateTo: null,
      reportFormOptions: reportFormOptions,
      groupBy: _.get(groupByOptions, "[0].value"),
      groupByOptions: groupByOptions,
      includeTransfers: _.get(includeTransfersOptions, "[0].value"),
      includeTransfersOptions: includeTransfersOptions,
      itemsPrinted: _.get(itemsPrintedOptions, "[0].value"),
      itemsPrintedOptions: itemsPrintedOptions,
      quantityFields: _.get(quantityFieldsOptions, "[0].value"),
      quantityFieldsOptions: quantityFieldsOptions,
      site: "",
      item: "",
      itemType: "",
      unit: ""
    };
  }

  isInvalidForm() {
    const {
      dateFrom,
      dateTo,
      reportForm,
      quantityFields,
      includeTransfers,
      itemsPrinted,
      groupBy
    } = this.state;
    console.log(this.state);
    return (
      dateFrom === null ||
      dateTo === null ||
      quantityFields === null ||
      includeTransfers === null ||
      itemsPrinted === null ||
      groupBy === null ||
      reportForm === null
    );
  }

  onSubmit() {
    const {
      quantityFields,
      includeTransfers,
      itemsPrinted,
      groupBy,
      site,
      item,
      itemType,
      unit,
      reportForm
    } = this.state;
    let dateTo = moment(this.state.dateTo).format("yyyyMMDD");
    let dateFrom = moment(this.state.dateFrom).format("yyyyMMDD");
    let mailTo = _.get(getUserInfo(), "email");
    let language = "v";

    const payload = {
      id: 600,
      data: {
        dateTo,
        dateFrom,
        site,
        item,
        itemType,
        unit,
        groupBy,
        includeTransfers,
        itemsPrinted,
        quantityFields,
        reportForm,
        language,
        mailTo,
        mailCC: "",
        mailBCC: ""
      }
    };
    this.setState({ loading: true });
    ReportApi.createReport(payload, res => {
      console.log(res);
      this.setState({ loading: false });
      if (res.success === true) {
        const resData = JSON.parse(res.data);
        if (_.get(resData, "Success") !== "0") {
          this.notify("success", "Tạo báo cáo thành công!");
        } else {
          this.notify("error", resData.Message);
        }
      } else {
        this.notify(
          "error",
          "Tạo báo cáo không thành công, vui lòng thử lại sau !"
        );
      }
    });
  }

  notify(variant, message) {
    this.props.enqueueSnackbar(message, {
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      variant
    });
  }

  componentDidMount() {
    // this.setState({showLoading: true}, () => {
    //     this.searchListPartnerFromAPI()
    // })
  }

  //****************************************************************************************************************

  //*********************************************************************************************************************

  render() {
    let {
      reportFormOptions,
      reportForm,
      groupBy,
      groupByOptions,
      includeTransfers,
      includeTransfersOptions,
      itemsPrinted,
      itemsPrintedOptions,
      quantityFields,
      quantityFieldsOptions,
      dateFrom,
      dateTo,
      loading
    } = this.state;
    return (
      <div className="container">
        <div
          className="loading"
          style={loading ? { display: "block" } : { display: "none" }}
        >
          <div className="lds-dual-ring"></div>
        </div>
        <div className="row">
          <Sidebar
            activeClass="report-summary"
            parentClass="report-management"
          />
          <div className="mb-4 col-md-10 tab-content">
            <div>
              <PageHeader routerEnable={false} title="Tổng hợp NXT" />
            </div>
            <div className="mt-3 mb-3" style={{ padding: "0 18px" }}>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    Mẫu báo cáo<span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    className="form-control kt-input pd-4-input shadow-none mb-1"
                    value={reportForm}
                    defaultValue={_.get(reportFormOptions, "[0].value")}
                    onChange={e => {
                      this.setState({
                        reportForm: e.target.value
                      });
                    }}
                  >
                    {reportFormOptions?.map(item => {
                      return item.value === this.props.data?.reportForm ? (
                        <option
                          disabled
                          style={{ backgroundColor: "#cbcbcb" }}
                          value={item.value}
                        >
                          {item.label}
                        </option>
                      ) : (
                        <option value={item.value}>{item.label}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-3 mb-3" style={{ padding: "0 18px" }}>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    Nhóm theo <span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    className="form-control kt-input pd-4-input shadow-none mb-1"
                    value={groupBy}
                    defaultValue={_.get(groupByOptions, "[0].value")}
                    onChange={e => {
                      this.setState({
                        groupBy: e.target.value
                      });
                    }}
                  >
                    {groupByOptions?.map(item => {
                      return item.value === this.props.data?.groupBy ? (
                        <option
                          disabled
                          style={{ backgroundColor: "#cbcbcb" }}
                          value={item.value}
                        >
                          {item.label}
                        </option>
                      ) : (
                        <option value={item.value}>{item.label}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-3 mb-3" style={{ padding: "0 18px" }}>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    Tính ps điều chuyển
                    <span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    className="form-control kt-input pd-4-input shadow-none mb-1"
                    value={includeTransfers}
                    defaultValue={_.get(includeTransfersOptions, "[0].value")}
                    onChange={e => {
                      this.setState({
                        includeTransfers: e.target.value
                      });
                    }}
                  >
                    {includeTransfersOptions?.map(item => {
                      return item.value ===
                        this.props.data?.includeTransfers ? (
                        <option
                          disabled
                          style={{ backgroundColor: "#cbcbcb" }}
                          value={item.value}
                        >
                          {item.label}
                        </option>
                      ) : (
                        <option value={item.value}>{item.label}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-3 mb-3" style={{ padding: "0 18px" }}>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    In các vật tư<span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    className="form-control kt-input pd-4-input shadow-none mb-1"
                    value={itemsPrinted}
                    defaultValue={_.get(itemsPrintedOptions, "[0].value")}
                    onChange={e => {
                      this.setState({
                        itemsPrinted: e.target.value
                      });
                    }}
                  >
                    {itemsPrintedOptions?.map(item => {
                      return item.value === this.props.data?.itemsPrinted ? (
                        <option
                          disabled
                          style={{ backgroundColor: "#cbcbcb" }}
                          value={item.value}
                        >
                          {item.label}
                        </option>
                      ) : (
                        <option value={item.value}>{item.label}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-3 mb-3" style={{ padding: "0 18px" }}>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    Cột số lượng<span style={{ color: "red" }}> *</span>
                  </label>
                  <select
                    className="form-control kt-input pd-4-input shadow-none mb-1"
                    value={quantityFields}
                    defaultValue={_.get(quantityFieldsOptions, "[0].value")}
                    onChange={e => {
                      this.setState({
                        quantityFields: e.target.value
                      });
                    }}
                  >
                    {quantityFieldsOptions?.map(item => {
                      return item.value === this.props.data?.quantityFields ? (
                        <option
                          disabled
                          style={{ backgroundColor: "#cbcbcb" }}
                          value={item.value}
                        >
                          {item.label}
                        </option>
                      ) : (
                        <option value={item.value}>{item.label}</option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="mt-3 mb-3" style={{ padding: "0 18px" }}>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    Mã kho <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="inputPassword w-100"
                    style={{
                      border: "1px solid #ced4da",
                      padding: "0 10px",
                      color: "#495057"
                    }}
                    placeholder="Mã kho"
                    maxLength={50}
                    onChange={e =>
                      this.setState({
                        site: e.target.value
                      })
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    Mã vật tư <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="inputPassword w-100"
                    style={{
                      border: "1px solid #ced4da",
                      padding: "0 10px",
                      color: "#495057"
                    }}
                    placeholder="Mã vật tư"
                    maxLength={50}
                    onChange={e =>
                      this.setState({
                        item: e.target.value
                      })
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex mb-2 pl-0">
                  <label className="col-2 label-item pl-0">
                    Loại vật tư <span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="inputPassword w-100"
                    style={{
                      border: "1px solid #ced4da",
                      padding: "0 10px",
                      color: "#495057"
                    }}
                    placeholder="Loại vật tư"
                    maxLength={50}
                    onChange={e =>
                      this.setState({
                        itemType: e.target.value
                      })
                    }
                  />
                </div>
              </div>
              {/*<div className="row">*/}
              {/*  <div className="col-12 d-flex mb-2 pl-0">*/}
              {/*    <label className="col-2 label-item pl-0">*/}
              {/*      Mã đơn vị cơ sở <span style={{ color: "red" }}> *</span>*/}
              {/*    </label>*/}
              {/*    <input*/}
              {/*      className="inputPassword w-100"*/}
              {/*      style={{*/}
              {/*        border: "1px solid #ced4da",*/}
              {/*        padding: "0 10px",*/}
              {/*        color: "#495057"*/}
              {/*      }}*/}
              {/*      placeholder="Mã đơn vị cơ sở"*/}
              {/*      maxLength={50}*/}
              {/*      onChange={e =>*/}
              {/*        this.setState({*/}
              {/*          unit: e.target.value*/}
              {/*        })*/}
              {/*      }*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*</div>*/}
            </div>

            <fieldset
              className="area-content-modal mb-3"
              style={{ width: "100%" }}
            >
              <legend
                className="font-14 "
                style={{ paddingLeft: 20 }}
                style={{ width: 80, paddingLeft: 9 }}
              >
                Thời gian
              </legend>
              <div className="row" style={{ padding: "0 9px" }}>
                <div className="col-12 d-flex mb-2 p-0">
                  <div className="col-2 d-flex mb-2 pl-0">
                    <label className="label-item " htmlFor="dateFrom">
                      Từ ngày
                      <span style={{ color: "red" }}> *</span>
                    </label>
                  </div>
                  <div className="col-4 d-flex mb-2 pl-0">
                    <DatePicker
                      dropdownMode="select"
                      id="dateFrom"
                      className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                      placeholderText="Từ ngày"
                      // onChangeRaw={this.handleDateChangeRaw}
                      selected={dateFrom === null ? "" : new Date(dateFrom)}
                      // value={dateFrom}
                      maxDate={new Date()}
                      // minDate={new Date()}
                      // value={dateIssue}
                      dateFormat="dd-MM-yyyy"
                      isClearable={dateFrom === null ? false : true}
                      // fixedHeight
                      // customInput={<input className="w-auto2 react-datepicker-wrapper2"/>}
                      selectsStart
                      showMonthDropdown
                      showYearDropdown
                      onChange={date => {
                        this.setState({
                          dateFrom: date === null ? null : date
                        });
                      }}
                    />
                  </div>
                  <div
                    className="col-2 d-flex mb-2 "
                    style={{ paddingLeft: 20 }}
                  >
                    <label className="label-item " htmlFor="dateTo">
                      Tới ngày
                      <span style={{ color: "red" }}> *</span>
                    </label>
                  </div>
                  <div className="col-4 d-flex mb-2 pl-0">
                    <DatePicker
                      dropdownMode="select"
                      id="dateTo"
                      className="w-auto3 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                      placeholderText="Đến ngày"
                      // onChangeRaw={this.handleDateChangeRaw}
                      selected={dateTo === null ? "" : new Date(dateTo)}
                      // customInput={<input className="w-auto3 react-datepicker-wrapper2"/>}
                      selectsEnd
                      showMonthDropdown
                      showYearDropdown
                      disabled={dateFrom === null ? true : false}
                      isClearable={dateTo === null ? false : true}
                      // fixedHeight
                      dateFormat="dd-MM-yyyy"
                      onChange={date => {
                        this.setState({
                          dateTo: date === null ? null : date
                        });
                      }}
                      startDate={new Date(dateFrom)}
                      endDate={new Date(dateTo)}
                      minDate={
                        dateFrom === null ? new Date() : new Date(dateFrom)
                      }
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div>
              <div className="d-flex justify-content-end mt-3 mb-2">
                <button
                  type="button"
                  className="ml-4 col-3 border-1-s background-btn type-button-fix btn shadow-none"
                  style={{
                    backgroundColor: "#169bd5",
                    borderColor: "#169bd5",
                    color: "white"
                  }}
                  // disabled={this.state.start.length === 0 || this.state.end.length === 0 || this.state.price.commercePrice === 0 || this.state.price.manufacturingPrice === 0 || this.state.price.buildingPrice === 0}
                  disabled={this.isInvalidForm()}
                  onClick={() => this.onSubmit()}
                >
                  Khởi tạo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withSnackbar(ReportSummary);
